/**
 * Application Constants
 * Centralized constants for the BioMercy application
 */

// Routes
export const ROUTES = {
  HOME: '/',
  CATALOGO: '/catalogo',
  NOSOTROS: '/nosotros',
  PRODUCTOS: '/productos',
  DOCTORES: '/doctores',
  CONTACTO: '/contacto',
};

// API Endpoints
export const API_ENDPOINTS = {
  PRODUCTOS: '/api/productos',
  DOCTORES: '/api/doctores',
  CONTACTO: '/api/contacto',
};

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_PREFERENCES: 'biomercy_user_preferences',
  CART: 'biomercy_cart',
};

// Breakpoints estándar
export const BREAKPOINTS = {
  MOBILE: 768, // Mobile: hasta 767px
  TABLET: 1024, // Tablet: 768px - 1023px
  DESKTOP: 1200, // Desktop: 1024px+
};

// Categorías de productos
export const CATEGORIAS = [
  { label: 'ANTIBIÓTICOS', value: 'antibioticos' },
  { label: 'CARDIOMETABÓLICA', value: 'cardiometabolica' },
  { label: 'RESPIRATORIA', value: 'respiratoria' },
  { label: 'Otros', value: 'otros' },
];

// Categorías permitidas en producción (derivado de CATEGORIAS)
export const CATEGORIAS_PERMITIDAS = CATEGORIAS.map(c => c.value);

// Lista blanca de productos permitidos - NOMBRES EXACTOS
export const PRODUCTOS_PERMITIDOS = [
  'Biofixima 400mg',
  'Bioproxina 500mg',
  'Cebiodroxilo 500mg',
  'Zitrobio',
  'Ambiodipina',
  'Atorvastatin',
  'BiodipinaLP',
  'Bionapril',
  'Bioprolol',
  'Biotelmic',
  'Biozartan',
  'Bureta',
  'Jeringa 3mm',
  'Jeringa 5mm',
  'Jeringa 10mm',
  'Jeringa 20mm',
  'Jeringa Insulina 2mm',
  'Microgotero',
  'Pantobio',
  'Pericraneales',
  'Carbiolol',
  'Glimebio',
  'Hidrobiozida',
  'Metforbio',
  'Olmebloc',
  'Rosuvastatin',
  'Bioez',
  'Bioflazacort',
  'Biogavalina',
  'Biosulfil',
  'Biotahistin',
  'Biotamsul',
  'Flubionazol',
  'Fludisina',
  'Quetiapine',
  'Chamber Sistema Flow-Vu',
  'Ciclesona-T',
  'DeslonilMt 5mg',
  'DeslonilMt 10mg',
  'Ventiduo-Plus',
];

// Productos que NO deben tener botón "más información"
export const PRODUCTOS_SIN_BOTON = [
  'bureta',
  'jeringa 3mm',
  'jeringa 5mm',
  'jeringa 10mm',
  'jeringa 20mm',
  'jeringa insulina 2mm',
  'microgotero',
  'pericraneales',
];

const constants = {
  ROUTES,
  API_ENDPOINTS,
  STORAGE_KEYS,
  BREAKPOINTS,
  CATEGORIAS,
  CATEGORIAS_PERMITIDAS,
  PRODUCTOS_PERMITIDOS,
  PRODUCTOS_SIN_BOTON,
};

export default constants;
